import GeneralTabbedPage from './general-tabbed-page';

export default GeneralTabbedPage;